import { CLIENT_PROFILE_TAB } from '@/pages/clients/client-profile/client-profile.constants'
import { ClientProfileTab } from '@/pages/clients/client-profile/client-profile.types'

import { ResidentProfileLinkSource } from './resident-profile-link.types'

// Note: which Resident Profile section a name link opens, per table page it was clicked from.
// Pages without a matching profile section yet (announcements, surveys, parking, market shop) open General
// information - re-point them here once that section exists, no table code needs to change.
export const RESIDENT_PROFILE_TAB_BY_SOURCE = {
  announcements: CLIENT_PROFILE_TAB.GeneralInformation,
  checklists: CLIENT_PROFILE_TAB.Inspections,
  contacts: CLIENT_PROFILE_TAB.GeneralInformation,
  'gift-cards': CLIENT_PROFILE_TAB.GiftCards,
  maintenance: CLIENT_PROFILE_TAB.Maintenance,
  'market-shop': CLIENT_PROFILE_TAB.GeneralInformation,
  packages: CLIENT_PROFILE_TAB.Packages,
  parking: CLIENT_PROFILE_TAB.GeneralInformation,
  reservations: CLIENT_PROFILE_TAB.Amenities,
  surveys: CLIENT_PROFILE_TAB.GeneralInformation,
  visitors: CLIENT_PROFILE_TAB.Visitors,
} as const satisfies Record<ResidentProfileLinkSource, ClientProfileTab>
